import {
    ACCOUNT_HOME_URL,
    ExternalRouteType,
    InternalRouteType,
    QRCODE_ROUTE,
    REDIRECT_ROUTE,
    SOCIAL_SIGN_UP_SUCCESS_ROUTE
} from '~routes/routes';

/**
 * Presets meant to generalize journeys
 * If a certain social platform have a different config
 * we can add a new one e.g. {PROVIDER}_SOCIAL_CONNECT
 */

export enum JourneyType {
    IN_STORE = 'in-store',
    SOCIAL_SIGNUP = 'social-signup',
    SOCIAL_SIGNIN = 'social-signin',
    SOCIAL_CONNECT = 'social-connect',
    ACCOUNT_SIGN_UP = 'account-sign-up'
}

export enum OnUserRegisteredBehavior {
    DEFAULT = 'default',
    // We won't take user to sign-in page automatically, we only show alert with CTA when we found existing ELC account that can be used to sign in
    IN_STORE = 'in-store'
}

export interface IJourney {
    loginOnSuccess?: boolean;
    postSubmitRoute: InternalRouteType | ExternalRouteType;
    // Whether create online account or not
    createOnlineAccount?: boolean;
    // Do not show QR Code/barcode
    hideScannableCode?: boolean;
    /** Behavior when API returns existing use during signup */
    onUserRegisteredBehavior?: OnUserRegisteredBehavior;
    redirectUrl?: string;
}

export const Journeys: Record<JourneyType, IJourney> = {
    [JourneyType.IN_STORE]: {
        postSubmitRoute: QRCODE_ROUTE,
        onUserRegisteredBehavior: OnUserRegisteredBehavior.IN_STORE
    },
    /** Coming from 3rd party Apps like KakaoGift, SSG */
    [JourneyType.SOCIAL_SIGNUP]: {
        loginOnSuccess: true,
        postSubmitRoute: SOCIAL_SIGN_UP_SUCCESS_ROUTE,
        onUserRegisteredBehavior: OnUserRegisteredBehavior.DEFAULT
    },
    [JourneyType.SOCIAL_SIGNIN]: {
        loginOnSuccess: true,
        postSubmitRoute: REDIRECT_ROUTE,
        redirectUrl: ACCOUNT_HOME_URL
    },
    /** Connect to LINE, Rakuten, Kakao etc. */
    [JourneyType.SOCIAL_CONNECT]: {
        loginOnSuccess: false,
        postSubmitRoute: REDIRECT_ROUTE,
        redirectUrl: ACCOUNT_HOME_URL
    },
    [JourneyType.ACCOUNT_SIGN_UP]: {
        loginOnSuccess: true,
        onUserRegisteredBehavior: OnUserRegisteredBehavior.DEFAULT,
        postSubmitRoute: ACCOUNT_HOME_URL
    }
};
